/**
 * The recruiter's interviewer setup is off unless a build sets
 * REACT_APP_INTERVIEWER_SETUP=true. With it off, posting a job and the job page
 * are exactly as before: no extra step, no tab, no request to Rio.
 *
 * Read at call time, not import time, so a test can turn it on for one case.
 */
export const isInterviewerSetupEnabled = (): boolean =>
  process.env.REACT_APP_INTERVIEWER_SETUP === 'true';
